import { realeriskConfig } from "./realerisk";
import { howdenConfig } from "./howden";
import { ClientConfig } from "../components/util/types/ClientConfig";

const client = process.env.REACT_APP_ENVIRONMENT!;

const configs: Record<string, ClientConfig> = {
  realerisk: realeriskConfig,
  howden: howdenConfig,
};

const currentClientConfig = configs[client.toLocaleLowerCase()];
if (!currentClientConfig) {
  throw new Error(`Client config for ${client} not found`);
}

export default currentClientConfig;
